import React from 'react';
import BlogCard from '../../components/BlogElements/BlogCard';
import Pagination from '../../components/common/Pagination';

const Blog3 = () => {
    const BlogData03 = [
        {
            id: '1',
            img: 'images/blog/1.jpg',
            author: 'Dessert - By Zoyena Ross',
            title: 'Bread Jam Fusion',
        },
        {
            id: '2',
            img: 'images/blog/2.jpg',
            author: 'Dessert - By Jacob Johnson',
            title: 'How to start food vlog',
        },
        {
            id: '3',
            img: 'images/blog/3.jpg',
            author: 'Dessert - By Parker Noel',
            title: 'Fod serving art tips',
        },
        {
            id: '4',
            img: 'images/blog/4.jpg',
            author: 'Dessert - By Austin Ryan',
            title: 'Misnighr Snack Bars',
        },
        {
            id: '5',
            img: 'images/blog/5.jpg',
            author: 'Dessert - By Zoyena Ross',
            title: 'Bread Jam Fusion',
        },
        {
            id: '6',
            img: 'images/blog/6.jpg',
            author: 'Dessert - By Jacob Johnson',
            title: 'How to start food vlog',
        },
        {
            id: '7',
            img: 'images/blog/7.jpg',
            author: 'Dessert - By Parker Noel',
            title: 'Fod serving art tips',
        },
        {
            id: '8',
            img: 'images/blog/8.jpg',
            author: 'Dessert - By Austin Ryan',
            title: 'Misnighr Snack Bars',
        },
    ];
    return (
        <div className="main-wrapper">
            <div className="container">

                <div className="blog_grid">
                    <div className="row">
                        {
                            BlogData03.map(data => <BlogCard
                                key={data.id}
                                data={data}
                            />)
                        }
                    </div>
                </div>

                <Pagination />
            </div>
        </div>
    );
};

export default Blog3;